import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { IoMdAdd } from "react-icons/io";
import Modal from "react-modal";
import Cookies from "js-cookie";
import CloseIcon from "@mui/icons-material/Close";
import { IoMdArrowDropright } from "react-icons/io";
import { useGlobalContext } from "../../../Context/GlobalContext";
import ClipLoader from "react-spinners/ClipLoader";
import PayrollAddReimbursementModel from "../../../components/Staff/Modals/PayrollAddReimbursementModel";
import PayrollReimbrusmentTotal from "../../../components/Staff/Modals/PayrollReimbursementTotal";
import { usePayrollContext } from "../../../Context/PayrollContext";
import PayrollFinalizedSidebar from "../../../components/Staff/Modals/PayrollFinalizedSidebar";

const PayrollReimbrusments = () => {
  const {
    isLoading,
    openToast,
    baseUrl,
    setSelectedStaff,
    selectDepartments,
    handleChangeDepartment,
    departments,
    resetState,
  } = useGlobalContext();
  const {
    fetchStaffs,
    monthYear,
    setMonthYear,
    staffs,
    loadingStaff,
    toggleOffCanvasAction,
    setIsOffCanvasOpenAction,
    setIsOffCanvasOpen,
    isOffCanvasOpen,
  } = usePayrollContext();

  const [isOpen, setIsOpen] = useState(false);
  const [activeReimbursementStaff, setActiveReimbursementStaff] =
    useState(null);
  const [selectedPayroll, setSelectedPayroll] = useState(null);
  const [payrollFinalized, setPayrollFinalized] = useState(false);

  const handleInputChange = (event) => {
    const selectedValue = event.target.value;
    setMonthYear(selectedValue);
  };
  console.log(monthYear);

  const toggleAccordion = () => {
    setIsOpen((isOpen) => !isOpen);
  };
  const toggleOffCanvas = () => {
    setIsOffCanvasOpen(!isOffCanvasOpen);
  };
  let subtitle;

  const [toggleDrop11, setToggleDrop11] = useState(false);

  function handledrop11() {
    setToggleDrop11(!toggleDrop11);
  }

  const [modalIsOpen9, setIsOpen9] = React.useState(false);
  function openModal9() {
    setIsOpen9(true);
  }
  function afterOpenModal9() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal9() {
    setIsOpen9(false);
  }
  console.log(staffs);
  // when onclick update staffaddReimbrusmentStaff

  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDrop = (dropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  const handleClickOutside = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setActiveDropdown(null);
    }
  };

  const toggleOffCanvasPayrollFinalized = () => {
    setPayrollFinalized(!payrollFinalized);
  };

  async function fetchPayrollDetails() { }

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <>
      <PayrollAddReimbursementModel
        staff={activeReimbursementStaff}
        setActiveReimbursementStaff={setActiveReimbursementStaff}
      />
      <PayrollReimbrusmentTotal
        staff={activeReimbursementStaff}
        offCanvas={toggleOffCanvas}
        isOffCanvasOpen={isOffCanvasOpen}
        setIsOffCanvasOpen={toggleOffCanvas}
        fetchStaffs={fetchStaffs}
      />
      <PayrollFinalizedSidebar
        offCanvas={toggleOffCanvasPayrollFinalized}
        isOffCanvasOpen={payrollFinalized}
        setIsOffCanvasOpen={toggleOffCanvasPayrollFinalized}
        data={selectedPayroll}
        fetchPayrollDetails={fetchPayrollDetails}
      />
      <div className="mt-[20px]">
        <div className="flex lg:flex-row xl:flex-row flex-col md:flex-col justify-between items-end gap-[15px] lg:gap-[0px]">
          <div className="flex lg:flex lg:flex-row flex-col gap-[10px] lg:gap-[20px] w-full">
            <div className="xl:w-[240px]">
              <label htmlFor="" className="font-medium text-[14px]">
                Payroll Month
              </label>
              <br />
              <input
                type="month"
                onChange={handleInputChange}
                value={monthYear}
                className="p-[8px] border rounded-md w-[100%] lg:w-[240px] text-sm focus-visible:outline-none"
              />
            </div>
            <div className="xl:w-[240px]">
              <label htmlFor="" className="font-medium text-[14px]">
                Company Branches
              </label>
              <br />
              <select className="p-[8px] border rounded-md w-[100%] lg:w-[240px] text-sm focus-visible:outline-none">
                <option>All Branches</option>
                <option>Demo Main Branchs</option>
              </select>
            </div>

            <div className="xl:w-[240px]">
              <label htmlFor="" className="font-medium text-[14px]">
                Departments
              </label>
              <br />
              <select
                value={selectDepartments}
                onChange={(e) => handleChangeDepartment(e.target.value)}
                className="p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none"
              >
                <option>Select a Department</option>
                {departments.map((departmentName, index) => (
                  <option key={index} value={departmentName?.department_name}>
                    {departmentName?.department_name}
                  </option>
                ))}
              </select>
            </div>

            {/* <div className="xl:w-[240px] set-incentive-div">
              <label htmlFor="" className="hidden font-medium text-[14px]">
                Departments
              </label>
              <br />

            </div> */}
          </div>
          {/* {toggleDrop11 && (
            <div className="">
              <Link to="#" className="font-normal text-[#27004a]">
                Reset
              </Link>
            </div>
          )} */}
          <div className="flex justify-end items-center w-full">
            <button
              onClick={resetState}
              className="flex justify-center items-center second-btn"
            >
              Reset
            </button>
          </div>
        </div>

        <div className="mt-[20px]">
          <div className="flex lg:flex-row xl:flex-row flex-col justify-between items-start lg:items-center xl:items-center gap-[10px]">
            <div className="relative summary-border rounded-[10px] w-full lg:w-[240px] xl:w-[240px]">
              <input
                type="text"
                placeholder="Search"
                className="px-[10px] py-[9px] pr-[26px] pl-[10px] rounded-3xl text-[13px] client-add focus-visible:outline-none"
              />
              <SearchIcon className="top-[12px] right-[6px] absolute text-gray-500 newadd2" />
            </div>

            {/* <div className="flex justify-end items-center gap-[10px] w-full">
              <input
                type="checkbox"
                onClick={handledrop11}
                id="breakdown"
                name="breakdown"
                value="breakdown"
              />
              <label for="breakdown "> Show Incentive Staff</label>
            </div> */}
            <button
              className="justify-center w-full lg:w-[240px] xl:w-[240px] second-btn"
              onClick={openModal9}
            >
              Import Reimbursements
            </button>
          </div>
        </div>

        <div className="border-[#dcdbdb] bg-white shadow-cs mt-[20px] border rounded-lg w-full h-[100%] overflow-x-auto">
          <table className="border-[#dcdbdb] border-collapse border rounded-lg w-full overflow-hidden table-auto">
            {/* Header with Toggle */}
            <thead
              className="border-gray-300 shadow-md border cursor-pointer"
              onClick={toggleAccordion}
            >
              <tr>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Name
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("name")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "name" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Job Title
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("job")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "job" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    CTC
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("ctc")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "ctc" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Payroll Finalized
                  </div>
                </th>

                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Total Reimbrusments
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("total")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "total" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">Action</div>
                </th>
              </tr>
            </thead>

            <tbody className="w-full">
              {loadingStaff && (
                <tr className="h-[100px]">
                  <td
                    colSpan="9"
                    className="border-[#dbdbdb] py-4 font-semibold text-center text-gray-600 text-xl whitespace-nowrap"
                  >
                    <ClipLoader color="#24007a" size={50} />
                  </td>
                </tr>
              )}

              {!loadingStaff &&
                staffs.length > 0 &&
                staffs?.map((staff) => {
                  let formattedPending = 0;
                  let formattedTotal = 0;
                  return (
                    <tr className="border">
                      <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                        <Link
                          onClick={() => setSelectedStaff(staff)}
                          to={`/personal-detail/${staff?.id}`}
                          className="font-medium text-[#8A25B0] cursor-pointer"
                        >
                          {staff?.name || "N/A"}
                        </Link>
                      </td>
                      <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                        {staff?.staffDetails?.job_title || "N/A"}
                      </td>
                      {staff?.staffDetails?.SalaryDetails[0]?.ctc_amount ? (
                        <>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                            {staff?.staffDetails?.SalaryDetails[0]
                              ?.ctc_amount ? (
                              <span className="font-medium">
                                ₹
                                {
                                  staff?.staffDetails?.SalaryDetails[0]
                                    ?.ctc_amount
                                }
                              </span>
                            ) : (
                              <Link
                                to="#"
                                className="border-[#24007a] hover:border-[#24007a] hover:bg-[#24007a] px-[10px] py-[6px] border rounded-xl text-[#24007a] hover:text-white transition-all"
                              >
                                <IoMdAdd className="inline mr-[5px]" /> Add CTC
                              </Link>
                            )}
                          </td>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-[#24007a] text-center text-xs whitespace-nowrap">
                            <button
                              onClick={() => {
                                setSelectedPayroll({
                                  ...staff,
                                  pending: formattedPending,
                                  total: formattedTotal,
                                });
                                setPayrollFinalized(true);
                              }}
                            >
                              {staff?.staffDetails?.SalaryDetails[0]
                                ?.payroll_finalized
                                ? "Yes"
                                : "No"}
                            </button>
                          </td>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-[#24007a] text-center text-xs whitespace-nowrap">
                            <button
                              onClick={() => {
                                setIsOffCanvasOpen(true);
                                setActiveReimbursementStaff(staff);
                              }}
                            >
                              {" "}
                              ₹{" "}
                              {staff?.staffDetails?.SalaryDetails[0]?.Reimbursement?.reduce(
                                (total, item) => total + item.amount,
                                0
                              ).toFixed(2) || "0.00"}
                            </button>
                          </td>
                          <td
                            className={`border-[#dbdbdb] p-[10px] border-r ${!staff?.staffDetails?.SalaryDetails[0]?.ctc_amount
                                ? "text-[#9f82e0]"
                                : "text-[#24007a]"
                              } text-center text-xs whitespace-nowrap`}
                          >
                            <button
                              disabled={
                                !staff?.staffDetails?.SalaryDetails[0]
                                  ?.ctc_amount
                              }
                              onClick={() => {
                                setIsOffCanvasOpenAction(true);
                                setActiveReimbursementStaff(staff);
                              }}
                            >
                              Add Reimbursement
                            </button>
                          </td>
                        </>
                      ) : (
                        // Show a single column if ctc_amount is not available
                        <td
                          className="border-[#dbdbdb] p-[10px] text-center text-xs whitespace-nowrap"
                          colSpan="6" // Span across all columns
                        >
                          Please{" "}
                          <Link
                            to={`/salary-details-edit/${staff?.id}`}
                            onClick={() => {
                              setSelectedStaff(staff);
                            }}
                            className="font-medium text-[#24007a]"
                          >
                            add ctc
                          </Link>{" "}
                          to see Reimbursement
                        </td>
                      )}
                    </tr>
                  );
                })}


              {
                !loadingStaff && staffs?.length == 0 && (
                  <tr className="h-[100px]">
                    <td
                      colSpan="9"
                      className="border-[#dbdbdb] py-4 text-[14px] text-black text-center whitespace-nowrap"
                    >
                      No Data Found
                    </td>
                  </tr>
                )
              }
            </tbody>

            {/* <div className='w-full'>
                <h2 className='p-[10px] pl-0 whitespace-nowrap'>Grand Total</h2>
            </div> */}
          </table>
        </div>
        <div className="w-full">
          <h2 className="p-[10px] pl-2 whitespace-nowrap">Grand Total</h2>
        </div>

        {/* when onclick update staff */}

        <Modal
          isOpen={modalIsOpen9}
          onAfterOpen={afterOpenModal9}
          onRequestClose={closeModal9}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px] text-center"
          >
            Import Reimbursements for all Staff
          </h2>
          <button
            onClick={closeModal9}
            className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="pb-2">
            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[0px]">
                <h4 className="m-0 font-medium">
                  Step 1. Download Salarybox Reimbursements Template
                </h4>
              </div>
              <div className="flex items-center">
                <Link
                  to="#"
                  className="p-1 rounded-md text-[13px] whitespace-nowrap outline-1 outline-dashed outline-offset-1"
                >
                  Download Template
                </Link>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[0px]">
                <h4 className="m-0 font-medium">
                  Step 3. Upload Reimbursements
                </h4>
              </div>
              <div className="flex items-center">
                <button className="p-1 rounded-md text-[13px] outline-1 outline-dashed outline-offset-1">
                  Import Reimbursements{" "}
                </button>
                {/* <input type='file' placeholder='ddjfksj'/> */}
              </div>
            </div>
          </div>
        </Modal>
        {/* when onclick update staff
         */}
      </div>
    </>
  );
};

export default PayrollReimbrusments;
